<template>
  <v-menu
    transition="slide-y-transition"
  >
    <template #activator="{ isActive, props }">
      <v-btn
        v-bind="props"
        rounded
        variant="outlined"
        class="font-weight-regular menu-button text-none pl-1 pr-1"
        :min-width="mobile ? 35 : 110"
      >
        <span
          v-if="!mobile"
          class="menu-button pl-3 pr-2"
        >{{ t(isActive ? "menuBlock.close" : "menuBlock.menu") }}</span>
        <v-icon :class="mobile ? 'menu-button' : 'menu-button pr-2'">
          {{ isActive ? 'mdi-close' : 'mdi-menu' }}
        </v-icon>
      </v-btn>
    </template>
    <template #default="data">
      <v-dialog
        v-if="mobile"
        width="100%"
        class="menu-dialog"
        content-class="primary below-menu"
        fullscreen
        :model-value="data.value"
        persistent
      >
        <div
          class="bg-primary pa-10"
          @click="data.value=false"
        >
          <slot />
        </div>
      </v-dialog>
      <div
        v-else
        class="bg-primary pa-10"
        width="300px"
      >
        <slot />
      </div>
    </template>
  </v-menu>
</template>

<script setup>
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { xs: mobile } = useDisplay();

</script>

<style scoped lang="scss">
  .menu-button, .menu-button.v-icon, .menu-button.v-btn.v-btn--outlined.v-btn--text {
    color: white;
    border-color: white;
  }

  .menu-button.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 64px;
    padding: 0 16px;
  }

  .menu.button.v-btn.v-size--default {
    font-size: 1rem;
  }

  .primary {
    background: rgb(var(--v-theme-primary));
    border-color: rgb(var(--v-theme-primary));
  }
</style>

<style lang="scss">
  //cannot be scoped as it's not part of main component
  //would be good to make value dynamic, but apparently not possible while using v-dialog
  .v-dialog.below-menu.v-dialog--fullscreen {
    top: 80px;
  }
</style>
